<template>
    <div
        id="bbva-form-4"
        class="p-4 md:p-6 shadow"
        :class="blueForm ? 'bg-light-blue' : 'bg-gray2'"
    >
        <div
            class="flex"
            :class="actualForm > 4 ? 'cursor-pointer' : 'cursor-default'"
            @click="onFormClick"
        >
            <div>
                <div
                    class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium"
                    :class="[blueForm ? ['bg-white'] : ['bg-light-blue', 'text-white']]"
                >4</div>
            </div>
            <div
                class="ml-4"
                :class="blueForm ? 'text-white' : ''"
            >
                <p class="text-lg sm:text-2xl font-medium leading-none xs:leading-tight">Datos de contacto</p>
                <p class="text-sm leading-tight mt-1 xs:mt-0">Recuerda que estos datos son obligatorios.</p>
            </div>
            <div class="ml-auto mt-2">
                <div
                    v-if="!blueForm"
                    :key="showForm"
                    :class="showForm ? 'triangle-up-black' : 'triangle-down-black'"
                ></div>
                <div
                    v-else
                    :key="showForm"
                    :class="showForm ? 'triangle-up-white' : 'triangle-down-white'"
                ></div>
            </div>
        </div>
        <div
            class="mt-4 form-4"
            :class="{'hidden': !showForm}"
        >
            <div class="line border-solid border-b border-gray3"></div>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form
                    class="mt-4 xs:w-4/6 sm:w-5/6 lg:w-4/6 mx-auto leading-tight sm:leading-normal"
                    @submit.prevent="handleSubmit(onSubmit)"
                >
                    <div class="flex flex-col space-y-2">
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|length:10"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'phone'"
                                    :value="formInputs.phone"
                                    @input="onPhoneChange"
                                >
                                    Teléfono*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes, invalid }"
                            >
                                <v-select-form
                                    :name="'mob_company'"
                                    :invalid="invalid"
                                    :classes="classes"
                                    :options="catalogs.mobCompanies"
                                    :loading="loading.mobCompanies"
                                    v-model="formInputs.mobCompany"
                                >
                                    Compañía telefónica*
                                </v-select-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <!-- <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|digits:10"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'landline'"
                                    :value="formInputs.landline"
                                    @input="formInputs.landline = $event"
                                >
                                    Teléfono fijo domicilio*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider> -->
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required|email"
                                v-slot="{ errors, classes }"
                            >
                                <input-form
                                    :classes="classes"
                                    :type="'email'"
                                    :name="'email'"
                                    :value="formInputs.email"
                                    @input="formInputs.email = $event"
                                >
                                    Correo electrónico*
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <radio-form
                                    :classes="classes"
                                    :name="'credit_card'"
                                    :value="formInputs.creditCard"
                                    @change="onCCardCheckChange"
                                >
                                    ¿Tienes alguna Tarjeta de Crédito (TDC) vigente?
                                </radio-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                :rules="!disabled.lastNumsCc ? 'required|numeric|max:4' : ''"
                                v-slot="{ errors, classes }"
                            >
                                <!-- <p class="text-sm">Indica los últimos 4 dígitos de tu TDC</p> -->
                                <input-form
                                    :classes="classes"
                                    :type="'text'"
                                    :name="'last_nums_cc'"
                                    :disabled="disabled.lastNumsCc"
                                    :value="formInputs.lastNumsCc"
                                    @input="formInputs.lastNumsCc = $event"
                                >
                                    Indica los últimos 4 dígitos de tu TDC
                                </input-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-4 w-full">
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <radio-form
                                    :classes="classes"
                                    :name="'auto_credit'"
                                    :value="formInputs.autoCredit"
                                    @change="formInputs.autoCredit = $event"
                                >
                                    ¿Has utilizado un crédito automotriz en los últimos 2 años?
                                </radio-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                            <ValidationProvider
                                class="sm:w-1/2"
                                rules="required"
                                v-slot="{ errors, classes }"
                            >
                                <radio-form
                                    :classes="classes"
                                    :name="'mort_credit'"
                                    :value="formInputs.mortCredit"
                                    @change="formInputs.mortCredit = $event"
                                >
                                    ¿Cuentas con algún Crédito Hipotecario?
                                </radio-form>
                                <span class="text-sm text-red">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="flex flex-col space-y-3 mt-8 w-full">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                        >
                            <checkbox-form
                                :name="'check-1'"
                                :classes="classes"
                                v-model="formInputs.checkCreditScore"
                            >
                                Autorizo la <span
                                    class="text-light-blue cursor-pointer"
                                    @click="showModals.creditScore = true"
                                >consulta de mi buró</span> de crédito.
                            </checkbox-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                        >
                            <checkbox-form
                                :name="'check-2'"
                                :classes="classes"
                                v-model="formInputs.treatmentData"
                            >
                                Autorizo el <span
                                    class="text-light-blue cursor-pointer"
                                    @click="showModals.treatmentData = true"
                                >tratamiento de mis datos.</span>
                            </checkbox-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                        >
                            <checkbox-form
                                :name="'check-3'"
                                :classes="classes"
                                v-model="formInputs.termsConditions"
                            >
                                He leído y acepto los <span
                                    class="text-light-blue cursor-pointer"
                                    @click="showModals.termsConditions = true"
                                >Términos y Condiciones</span> del producto.
                            </checkbox-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                        >
                            <checkbox-form
                                :name="'check-4'"
                                :classes="classes"
                                v-model="formInputs.hmm"
                            >
                                Autorizo a HMM el <span
                                    class="text-light-blue cursor-pointer"
                                    @click="showModals.hmm = true"
                                >tratamiento de mis datos</span>
                            </checkbox-form>
                            <span class="text-sm text-red">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="mt-6 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 items-center justify-end">
                        <button
                            type="button"
                            class="hyundai-button w-40 py-0 h-8 bg-light-blue"
                            @click="saveProgress"
                            :disabled="savingProgress"
                        >{{ !savingProgress ? 'Guardar avance' : 'Guardando...' }}</button>
                        <button
                            type="submit"
                            class="hyundai-button w-40 py-0 h-8"
                        >Siguiente</button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
        <modal-form
            :show="showModals.creditScore"
            @close="showModals.creditScore = false"
        >
            <p class="font-medium text-center">Consulta de mi buró de crédito</p>
            <p class="mt-4 text-justify">Por este conducto, al dar clic, yo {{ fullName }} autorizo expresa e irrevocablemente a BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México, para que solicité a la(s) sociedad(es) de información crediticia Nacionales o Extranjeras que considere necesaria(s) toda la información relativa mi historial crediticio, así como para que proporcione información sobre dicho historial. Declaró que conozco: la naturaleza y alcance de la información que se solicitará; las consecuencias e importancia de la información que la(s) Sociedad(es) de Información crediticia le proporcionará(n) a BBVA, así como el uso que esta hará de tal información.</p>
        </modal-form>
        <modal-form
            :show="showModals.treatmentData"
            @close="showModals.treatmentData = false"
        >
            <p class="font-medium text-center">Tratamiento de mis datos por BBVA</p>
            <p class="mt-4 text-justify">Otorgó mi consentimiento a BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México, para que trate mis datos personales, financieros y patrimoniales, con fines de evaluación y contratación de un crédito de auto, de conformidad con el <span
                    class="text-light-blue underline cursor-pointer"
                    @click="onClickPrivacy"
                >Aviso de Privacidad BBVA.</span></p>
        </modal-form>
        <modal-form
            :show="showModals.termsConditions"
            @close="showModals.termsConditions = false"
        >
            <p class="font-medium text-center">Términos y condiciones</p>
            <p class="mt-4">Términos y condiciones de crédito auto Consumer Finance:</p>
            <ul class="mt-4 text-justify">
                <li class="flex"><span>-</span> <span class="ml-1">Sujeto a la aprobación de crédito.</span></li>
                <li class="flex"><span>-</span> <span class="ml-1">El cliente deberá firmar el contrato de crédito correspondiente a sus anexos.</span></li>
                <li class="flex"><span>-</span> <span class="ml-1">El cliente deberá endosar la factura del vehículo en garantía en favor de BBVA.</span></li>
                <li class="flex"><span>-</span> <span class="ml-1">El cliente deberá contar con un seguro de daños con cobertura amplia al vehículo y un seguro de vida, ya sea con la Aseguradora que indique BBVA o con la Aseguradora de su preferencia.</span></li>
                <li class="flex"><span>-</span> <span class="ml-1">En ambos seguros, BBVA deberá aparecer como beneficiario preferente e irrevocable.</span></li>
                <li class="flex"><span>-</span> <span class="ml-1">Los términos y condiciones de contratación, así como las comisiones que aplican al producto pueden ser consultadas en <a
                            href="https://www.bbva.mx"
                            class="text-light-blue underline"
                            target="_blank"
                        >www.bbva.mx</a></span></li>
            </ul>
        </modal-form>
        <modal-form
            :show="showModals.privacyPolicy"
            @close="showModals.privacyPolicy = false"
        >
            <p class="font-medium text-center">Aviso de Privacidad</p>
            <p class="mt-4 text-justify">BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México, con domicilio en Avenida Paseo de la Reforma número 510 Colonia Juárez Alcaldía Cuauhtémoc, Código Postal 06600, Ciudad de México, recaba tus datos personales para verificar tu identidad, así como para administrar, operar y dar seguimiento a los servicios y productos que solicitas o contratas. Puedes consultar el Aviso de Privacidad Integral en cualquiera de nuestras sucursales y en <a
                    href="https://www.bbva.mx"
                    class="text-light-blue underline"
                    target="_blank"
                >www.bbva.mx</a></p>
        </modal-form>
        <modal-form
            :show="showModals.hmm"
            @close="showModals.hmm = false"
        >
            <p class="font-medium text-center">Tratamiento de mis datos por HMM</p>
            <p class="mt-4 text-justify">Hyundai Motor de México, S. de R.L. de C.V., con domicilio en Antonio Dovali Jaime número 70, Torre D, Piso 10 en la Ciudad de México, le informa que los datos personales que Usted proporciona serán utilizados con fines de i) Identificar al titular de los datos personales, ii) registrarlo en nuestros sistemas como cliente o prospecto de cliente, iii) Tener sus datos de contacto, iv) Poder contactarlo, v) Fines comerciales y de Marketing, entre otros. Para mayor información acerca del tratamiento de sus datos personales y los derechos que Usted puede hacer valer respecto de los mismos, le pedimos consultar el aviso de privacidad integral en nuestra página web <a
                    href="https://www.hyundai.com.mx/privacidad/"
                    class="text-light-blue underline"
                    target="_blank"
                >www.hyundai.com.mx/privacidad/</a></p>
        </modal-form>
    </div>
</template>

<script>
// Components to form validations
import {
    ValidationProvider,
    ValidationObserver,
    setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");
// Validaciones personalizadas para el formulario
import "../helpers/form_validations";
// Función para importar los catálogos
import { getCatalog } from "../helpers/helpers_functions";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: [
        "mainCheck",
        "actualForm",
        "savingProgress",
        "mainEmail",
        "fullName",
    ],
    data() {
        return {
            showForm: false,
            formComplete: false,
            formInputs: {
                phone: "",
                mobCompany: "",
                email: this.mainEmail,
                creditCard: "",
                lastNumsCc: "",
                autoCredit: "",
                mortCredit: "",
                checkCreditScore: "",
                treatmentData: "",
                termsConditions: "",
                hmm: "",
            },
            catalogs: {
                mobCompanies: [],
            },
            loading: {
                mobCompanies: false,
            },
            disabled: {
                lastNumsCc: false,
            },
            showModals: {
                creditScore: false,
                treatmentData: false,
                termsConditions: false,
                privacyPolicy: false,
                hmm: false,
            },
        };
    },
    watch: {
        showForm(newVal) {
            if (newVal) {
                this.$emit("form-open", 4);
                $(".form-4").slideDown();
                if (this.emptyCatalog) {
                    this.getCatalogs();
                }
            } else {
                this.$emit("form-closed", 4);
                $(".form-4").slideUp();
            }
        },
        mainEmail(newVal) {
            this.formInputs.email = newVal;
        },
    },
    methods: {
        onClickPrivacy() {
            this.showModals.treatmentData = false;
            this.showModals.privacyPolicy = true;
        },
        onFormClick() {
            if (this.mainCheck && !this.showForm && this.actualForm > 3) {
                this.$eventBus.$emit("hide-forms");
                this.showForm = true;
                this.formComplete = false;
            }
        },
        onSubmit(e) {
            if (!this.emptyCatalog) {
                // this.addInputsDesc();

                const formData = {
                    formNum: 4,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("form-validated", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        // Function to add descriptions to formInputs based on id
        // addInputsDesc() {
        //     this.formInputs.mobCompanyDesc = this.formInputs.mobCompany
        //         ? this.catalogs.mobCompanies.find(
        //               (option) => option.id === this.formInputs.mobCompany
        //           ).description
        //         : "";
        // },
        saveProgress() {
            if (!this.emptyCatalog) {
                // this.addInputsDesc();

                const formData = {
                    formNum: 4,
                    formInputs: { ...this.formInputs },
                };

                this.$emit("save-progress", formData);
            } else {
                this.$emit("charging-catalogs");
            }
        },
        setInputs(inputs) {
            // this.formInputs.email = inputs.email;
            this.formInputs.phone = inputs.mobile_number;
            this.formInputs.mobCompany = inputs.phoneCompany_id;
            this.onCCardCheckChange(inputs.hasCreditCard);
            this.formInputs.lastNumsCc = inputs.lastFourDigits;
            this.formInputs.autoCredit = inputs.hasAutoLoan;
            this.formInputs.mortCredit = inputs.hasMortgageLoan;
            this.formInputs.checkCreditScore = inputs.checkCreditScore;
            this.formInputs.treatmentData = inputs.treatmentData;
            this.formInputs.termsConditions = inputs.termsConditions;
            this.formInputs.hmm = inputs.hmm;
        },
        getCatalogs() {
            this.loading.mobCompanies = true;
            getCatalog("MOBILE_COMPANIES")
                .then((resp) => {
                    this.catalogs.mobCompanies = resp;
                    this.loading.mobCompanies = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading.mobCompanies = false;
                });
        },
        showModal(num) {
            this.$modal.show("modal-" + num);
        },
        onCCardCheckChange(value) {
            this.formInputs.creditCard = value;
            this.disabled.lastNumsCc = !(value > 0);
        },
        onPhoneChange(value) {
            const regexp = /^[\d]{1,10}$/;
            this.formInputs.phone = regexp.test(value)
                ? value
                : value.slice(0, -1);
        },
    },
    computed: {
        emptyCatalog() {
            let empty = false;
            for (const key in this.catalogs) {
                if (!this.catalogs[key].length) {
                    empty = true;
                    break;
                }
            }
            return empty;
        },
        blueForm() {
            return this.formComplete && this.actualForm > 3;
        },
    },
    created() {
        this.$eventBus.$on("show-form-4", () => {
            this.showForm = true;
            this.formComplete = false;
        });
        this.$eventBus.$on("hide-forms", () => {
            this.showForm = false;
        });
        this.$eventBus.$on("complete-form-4", () => {
            this.showForm = false;
            this.formComplete = true;
        });
        this.$eventBus.$on("setFormsInputs", (inputs) => {
            this.setInputs(inputs);
        });
    },
};
</script>

<style>
</style>